'use client';

import { ResidualRiskLabel, RiskDimensionLabelDetail } from '@api';
import { action, makeObservable, observable } from 'mobx';

export class RiskProfileStore {
  residualRisks: ResidualRiskLabel[] | null = null;

  dimensionRiskLabels: RiskDimensionLabelDetail[] | null = null;

  minOrder: number | null = null;

  maxOrder: number | null = null;

  numberOfDimensions: number = 0;

  constructor() {
    makeObservable(this, {
      residualRisks: observable,
      dimensionRiskLabels: observable,
      setResidualRisks: action.bound,
      setDimensionRiskLabels: action.bound,
      setNumberOfDimensions: action.bound,
    });
  }

  setResidualRisks(data) {
    this.residualRisks = data;
    this.minOrder = Math.min(...data.map(item => item.order));
    this.maxOrder = Math.max(...data.map(item => item.order));
  }

  setDimensionRiskLabels(data) {
    this.dimensionRiskLabels = data;
  }

  setNumberOfDimensions(data) {
    this.numberOfDimensions = data;
  }
}

export const riskProfileStore = new RiskProfileStore();
